import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';

const Header = () => {
  const { hasPermission } = useAuth();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { user, logout, isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <header className="bg-gradient-to-r from-slate-900 to-slate-800 shadow-2xl border-b border-yellow-400">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="text-2xl font-bold text-white">
            <span className="text-yellow-400">CRESCENT</span> TRADERS
          </Link>
          
          {/* Desktop Navigation */}
          <nav className="hidden md:flex space-x-8">
            <Link to="/" className="text-white hover:text-yellow-400 transition-colors font-medium">Home</Link>
            <Link to="/about" className="text-white hover:text-yellow-400 transition-colors font-medium">About Us</Link>
            <Link to="/catalogue" className="text-white hover:text-yellow-400 transition-colors font-medium">Catalogue</Link>
            <Link to="/contact" className="text-white hover:text-yellow-400 transition-colors font-medium">Contact</Link>
            <Link to="/testimonials" className="text-white hover:text-yellow-400 transition-colors font-medium">Testimonials</Link>
            <Link to="/quote" className="text-white hover:text-yellow-400 transition-colors font-medium">Get Quote</Link>
			{hasPermission('manage_users') || hasPermission('manage_products') || hasPermission('manage_quotes') ? (
			  <Link to="/admin" className="text-yellow-400 hover:text-yellow-300 transition-colors font-medium">Admin</Link>
			) : null}
          </nav>

          {/* Auth Buttons */}
          <div className="hidden md:flex items-center space-x-4">
            {isAuthenticated ? (
              <div className="flex items-center space-x-4">
                <span className="text-white">Welcome, <span className="text-yellow-400 font-semibold">{user?.username}</span></span>
                <Button onClick={handleLogout} variant="outline" className="text-yellow-400 border-yellow-400 hover:bg-yellow-400 hover:text-slate-900">
                  Logout
                </Button>
              </div>
            ) : (
              <Link to="/login">
                <Button variant="outline" className="text-yellow-400 border-yellow-400 hover:bg-yellow-400 hover:text-slate-900">
                  Login
                </Button>
              </Link>
            )}
          </div>

          {/* Mobile menu button */}
          <button
            className="md:hidden text-white"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <div className="md:hidden py-4 border-t border-orange-300">
            <div className="flex flex-col space-y-2">
              <Link to="/" className="text-white hover:text-orange-100 py-2">Home</Link>
              <Link to="/about" className="text-white hover:text-orange-100 py-2">About Us</Link>
              <Link to="/catalogue" className="text-white hover:text-orange-100 py-2">Catalogue</Link>
              <Link to="/contact" className="text-white hover:text-orange-100 py-2">Contact</Link>
              <Link to="/testimonials" className="text-white hover:text-orange-100 py-2">Testimonials</Link>
              <Link to="/quote" className="text-white hover:text-orange-100 py-2">Get Quote</Link>
              {isAuthenticated && user?.role === 'admin' && (
                <Link to="/admin" className="text-white hover:text-orange-100 py-2">Admin</Link>
              )}
              {isAuthenticated ? (
                <Button onClick={handleLogout} variant="outline" className="text-orange-500 border-white mt-4">
                  Logout
                </Button>
              ) : (
                <Link to="/login" className="mt-4">
                  <Button variant="outline" className="text-orange-500 border-white">
                    Login
                  </Button>
                </Link>
              )}
            </div>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;